module.exports = __webpack_public_path__ + "img/07_Roof to Wall Strap.b19d8f09.png";